var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.dataToShow > 0,
      "overflow": "overflow-hidden"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "py-5 md:py-15 md:px-20 lg:px-10 xl:px-40 2xl:py-20 2xl:px-32"
  }, [_vm.dataToShow === 1 ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Choisir le type de CV")]), _vm._v(" "), _c('div', {
    staticClass: "2xl:mx-28 grid grid-cols-2 justify-center md:space-x-5 items-start pr-5"
  }, [_c('div', {
    staticClass: "col-span-1 flex flex-col h-48 md:h-88 w-max group"
  }, [_c('div', [_c('div', {
    staticClass: "text-center mb-5"
  }, [_vm._v("Classique")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "top-0 left-0 absolute w-full h-40 md:h-80 rounded-md z-20 cursor-pointer transition-all duration-700 bg-transparent bg-opacity-0 group-hover:bg-indigo-600 group-hover:bg-opacity-25",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.chooseType(_vm.constants.CV_TYPES.BASIC);
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "h-40 md:h-80 object-contain border border-gray-600 border-opacity-25 rounded-lg",
    attrs: {
      "src": "/assets/img/cv/cv_classic.png",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-1 flex flex-col relative w-max group"
  }, [_c('div', {
    staticClass: "w-max"
  }, [_c('div', {
    staticClass: "text-center mb-5"
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "top-0 left-0 absolute w-full h-28 md:h-56 rounded-md z-20 cursor-pointer transition-all duration-700 bg-transparent bg-opacity-0 group-hover:bg-indigo-600 group-hover:bg-opacity-25",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.chooseType(_vm.constants.CV_TYPES.DASHBOARD);
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "h-28 md:h-56 object-contain border border-gray-600 border-opacity-25 rounded-lg",
    attrs: {
      "src": "/assets/img/cv/cv_dashboard.png",
      "alt": ""
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _vm.dataToShow === 2 ? _c('div', [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Créer un nouveau CV " + _vm._s(_vm.cv.type === 'dashboard' ? 'dashboard' : ''))]), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col items-center mb-5",
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createNewCv();
      }
    }
  }, [_c('input-text', {
    staticClass: "lg:w-1/2 mb-5",
    attrs: {
      "name": "title",
      "libelle": "Titre de mon CV",
      "value": _vm.cv.title,
      "error": true,
      "msg-error": _vm.error,
      "maxlength": 50
    },
    on: {
      "input": function (newValue) {
        _vm.cv.title = newValue;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "w-max-content w-max"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "bg-color-square": _vm.saving ? 'bg-gray-600' : 'bg-pink-600',
      "libelle": "Créer un nouveau CV",
      "type-shadow": _vm.saving ? 'shadow-gray' : 'shadow-pink'
    },
    on: {
      "clickAction": function ($event) {
        return _vm.createNewCv();
      }
    }
  })], 1)])], 1)]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }